export const firebaseConfig = {
    apiKey: '$(FirebaseSettings.ApiKey)',
    authDomain: "mymasjid-mobile.firebaseapp.com",
    databaseURL: "https://mymasjid-mobile.firebaseio.com",
    projectId: "mymasjid-mobile",
    storageBucket: "mymasjid-mobile.firebasestorage.app",
    messagingSenderId: '$(FirebaseSettings.MessagingSenderId)',
    appId: '$(FirebaseSettings.AppId)',
    measurementId: '$(FirebaseSettings.MeasurementId)'
};